module.exports = __webpack_public_path__ + "static/universityofwisconsinmadison-54077f1ca59800f1bccd0d54fdc28b44.svg";